"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var Pagination_1 = __importDefault(require("@mui/material/Pagination"));
var statusChip_1 = require("./statusChip");
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var ENDPOINT = '/app/admin/twi/subscriptions';
var SEARCH_DEBOUNCE_MS = 300;
var EMPTY = {
    subscribers: [],
    pagination: { page: 1, per_page: 25, total: 0, total_pages: 1 },
    stats: { total_active: 0, total_past_due: 0, monthly_revenue: 0 },
};
function formatDate(d) {
    if (!d)
        return '—';
    var _a = d.split('-').map(Number), y = _a[0], m = _a[1], day = _a[2];
    return new Date(y, m - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
var StatCard = function (_a) {
    var label = _a.label, value = _a.value, sub = _a.sub;
    return (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: { p: '18px 22px', borderRadius: 2, backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', flex: 1 } },
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 0.5 } }, (0, Lang_js_1.__)(label)),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '28px', fontWeight: 700, color: NAVY, lineHeight: 1 } }, value),
        sub && react_1.default.createElement(Typography_1.default, { sx: { mt: 0.5, fontSize: '12px', color: '#aaa' } }, (0, Lang_js_1.__)(sub))));
};
var GRID = '2.2fr 1fr 1.4fr 1.6fr 0.9fr 1fr 90px';
var HEADINGS = ['Name / Email / Username', 'Member ID', 'Plan', 'Status', 'Amount', 'Since', 'Actions'];
/**
 * Searching and paging happen on the server, mirroring the renewals list. Loading every
 * subscription row into the page and filtering it here was both a growing payload — the 1 MB ALB
 * cap is a correctness boundary, not a latency one — and the reason a WordPress username could not
 * be searched at all: it was never in the payload to search.
 */
var AdminSubscriberList = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var initial = _a.initial;
    var _h = (0, react_1.useState)(initial), data = _h[0], setData = _h[1];
    var _j = (0, react_1.useState)(''), search = _j[0], setSearch = _j[1];
    var _k = (0, react_1.useState)(''), debounced = _k[0], setDebounced = _k[1];
    var _l = (0, react_1.useState)('all'), statusFilter = _l[0], setStatusFilter = _l[1];
    var _m = (0, react_1.useState)((_c = (_b = initial.pagination) === null || _b === void 0 ? void 0 : _b.page) !== null && _c !== void 0 ? _c : 1), page = _m[0], setPage = _m[1];
    var _o = (0, react_1.useState)(false), loading = _o[0], setLoading = _o[1];
    var _p = (0, react_1.useState)(null), error = _p[0], setError = _p[1];
    var hydrated = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () { return setDebounced(search); }, SEARCH_DEBOUNCE_MS);
        return function () { return clearTimeout(timer); };
    }, [search]);
    // A new search or filter is a new result set, so it starts at page one — otherwise a person on
    // page 4 searches and gets an empty page 4 of two results.
    (0, react_1.useEffect)(function () {
        if (hydrated.current)
            setPage(1);
    }, [debounced, statusFilter]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!hydrated.current) {
            hydrated.current = true;
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        var params = new URLSearchParams({ page: String(page), per_page: String((_b = (_a = data.pagination) === null || _a === void 0 ? void 0 : _a.per_page) !== null && _b !== void 0 ? _b : 25) });
        if (debounced.trim() !== '')
            params.set('search', debounced.trim());
        if (statusFilter !== 'all')
            params.set('status', statusFilter);
        fetch("".concat(ENDPOINT, "?").concat(params.toString()), {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
        })
            .then(function (res) {
            if (!res.ok)
                throw new Error("HTTP ".concat(res.status));
            return res.json();
        })
            .then(function (body) {
            if (cancelled)
                return;
            setData({
                subscribers: body.subscribers || [],
                pagination: body.pagination || EMPTY.pagination,
                stats: body.stats || EMPTY.stats,
            });
        })
            .catch(function (e) {
            if (cancelled)
                return;
            console.warn('AdminSubscriberList: fetch failed', e);
            setError((0, Lang_js_1.__)('Could not load the subscriber list. Please try again.'));
        })
            .finally(function () { if (!cancelled)
            setLoading(false); });
        // Drop a response whose query has been superseded, so a slow earlier request cannot
        // overwrite a faster later one.
        return function () { cancelled = true; };
    }, [debounced, statusFilter, page]);
    var subscribers = (_d = data.subscribers) !== null && _d !== void 0 ? _d : [];
    var pagination = (_e = data.pagination) !== null && _e !== void 0 ? _e : EMPTY.pagination;
    var stats = __assign(__assign({}, EMPTY.stats), ((_f = data.stats) !== null && _f !== void 0 ? _f : {}));
    return (react_1.default.createElement(Box_1.default, { sx: { p: 2, maxWidth: '1400px', mx: 'auto', backgroundColor: '#f5f6f8', minHeight: '80vh' } },
        react_1.default.createElement(Box_1.default, { sx: { mb: 3 } },
            react_1.default.createElement(Typography_1.default, { component: "a", href: "/app/admin", sx: { display: 'block', mb: 1.5, fontSize: '13px', fontWeight: 600, color: NAVY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } },
                "\u2190 ",
                (0, Lang_js_1.__)('Admin Dashboard')),
            react_1.default.createElement(Typography_1.default, { component: "h1", sx: { mt: 0.5, fontSize: '24px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('TWI Subscribers'))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' } },
            react_1.default.createElement(StatCard, { label: "Active Subscribers", value: stats.total_active, sub: "TWI & Seminar Leader" }),
            react_1.default.createElement(StatCard, { label: "Past Due", value: stats.total_past_due, sub: "Needs attention" }),
            react_1.default.createElement(StatCard, { label: "Monthly Revenue", value: "$".concat(Number((_g = stats.monthly_revenue) !== null && _g !== void 0 ? _g : 0).toFixed(2)), sub: "Active + past due" })),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: '14px 18px', mb: 2, borderRadius: 2, backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.07)', display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
            } },
            react_1.default.createElement(TextField_1.default, { placeholder: (0, Lang_js_1.__)('Search by name, username, email, member ID, or Stripe sub ID…'), value: search, onChange: function (e) { return setSearch(e.target.value); }, size: "small", sx: { flex: 1, minWidth: '260px' }, InputProps: {
                    startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '16px', color: '#aaa' } }, "\u2315"))),
                } }),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' } }, statusChip_1.STATUS_FILTERS.map(function (opt) { return (react_1.default.createElement(Box_1.default, { key: opt.value, onClick: function () { return setStatusFilter(opt.value); }, sx: {
                    px: '14px', py: '5px', borderRadius: '20px', cursor: 'pointer',
                    fontSize: '13px', fontWeight: 600,
                    backgroundColor: statusFilter === opt.value ? NAVY : 'transparent',
                    color: statusFilter === opt.value ? '#fff' : '#555',
                    border: "1px solid ".concat(statusFilter === opt.value ? NAVY : '#ddd'),
                    transition: 'all 0.15s ease',
                    '&:hover': { borderColor: NAVY, color: statusFilter === opt.value ? '#fff' : NAVY },
                } }, (0, Lang_js_1.__)(opt.label))); })),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888', ml: 'auto', whiteSpace: 'nowrap' } }, loading ? (0, Lang_js_1.__)('Searching…') : "".concat(pagination.total, " ").concat(pagination.total === 1 ? (0, Lang_js_1.__)('result') : (0, Lang_js_1.__)('results')))),
        error && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#9e3a3a', mb: '12px' } }, error)),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: { borderRadius: 2, backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', overflow: 'hidden' } },
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'grid', gridTemplateColumns: GRID, px: '18px', py: '10px',
                    backgroundColor: '#f8f9fa', borderBottom: '1px solid #e8e8e8',
                } }, HEADINGS.map(function (h) { return (react_1.default.createElement(Typography_1.default, { key: h, sx: { fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px' } }, (0, Lang_js_1.__)(h))); })),
            subscribers.length === 0 ? (react_1.default.createElement(Box_1.default, { sx: { p: '32px', textAlign: 'center' } },
                react_1.default.createElement(Typography_1.default, { sx: { color: '#aaa', fontSize: '14px' } }, (0, Lang_js_1.__)('Nobody matched. Try a username, the member ID, or part of the email address.')))) : (subscribers.map(function (s, idx) {
                var _a, _b, _c;
                return (react_1.default.createElement(Box_1.default, { key: s.id, sx: {
                        display: 'grid', gridTemplateColumns: GRID, px: '18px', py: '14px',
                        borderBottom: idx < subscribers.length - 1 ? '1px solid #f0f0f0' : 'none',
                        alignItems: 'center', '&:hover': { backgroundColor: '#fafbfc' },
                    } },
                    react_1.default.createElement(Box_1.default, { sx: { minWidth: 0 } },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: NAVY } }, s.name || '—'),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888', mt: '2px', wordBreak: 'break-all' } }, s.email || '—'),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888', mt: '2px', fontFamily: 'monospace' } }, s.user_login || '—')),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', fontFamily: 'monospace' } }, (_a = s.member_id) !== null && _a !== void 0 ? _a : '—'),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#333', lineHeight: 1.4 } }, (_b = s.plan) !== null && _b !== void 0 ? _b : (0, Lang_js_1.__)('Unknown')),
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement(statusChip_1.DerivedStatusBadge, { status: s.status, through: s.status_through })),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: '#333' } },
                        "$",
                        Number((_c = s.amount) !== null && _c !== void 0 ? _c : 0).toFixed(2)),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888' } }, formatDate(s.start_date)),
                    react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1 } },
                        react_1.default.createElement(Box_1.default, { component: "a", href: "".concat(ENDPOINT, "/").concat(s.id), sx: {
                                px: '10px', py: '5px', borderRadius: '4px',
                                backgroundColor: NAVY, color: '#fff',
                                fontSize: '12px', fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap',
                                '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                            } }, (0, Lang_js_1.__)('View')),
                        s.wp_user_id && (react_1.default.createElement(Box_1.default, { component: "a", href: "/app/admin/twi/lookup/".concat(s.wp_user_id), sx: {
                                px: '10px', py: '5px', borderRadius: '4px',
                                border: '1px solid #d5d5e0', color: NAVY,
                                fontSize: '12px', fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap',
                                '&:hover': { backgroundColor: '#f4f4f8', textDecoration: 'none', color: NAVY },
                            } }, (0, Lang_js_1.__)('Member'))))));
            }))),
        pagination.total_pages > 1 && (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center', mt: 2 } },
            react_1.default.createElement(Pagination_1.default, { count: pagination.total_pages, page: pagination.page, onChange: function (_, value) { return setPage(value); }, shape: "rounded" })))));
};
var adminBillingListEl = document.getElementById('msia-admin-billing-container');
if (adminBillingListEl) {
    var bootstrapEl = document.getElementById('msia-admin-billing-bootstrap');
    var initial = EMPTY;
    try {
        initial = (bootstrapEl === null || bootstrapEl === void 0 ? void 0 : bootstrapEl.textContent) ? __assign(__assign({}, EMPTY), JSON.parse(bootstrapEl.textContent)) : EMPTY;
    }
    catch (e) {
        console.warn('AdminSubscriberList: parse error', e);
    }
    (0, mountIsland_1.mountIsland)(adminBillingListEl, react_1.default.createElement(AdminSubscriberList, { initial: initial }));
}
exports.default = AdminSubscriberList;
